<template>
  <div class="content">
    <!-- Monitors -->
    <div class="row pt-3">
      <div class="col mt-2 px-2">
        <v-card min-height="175px">
          <v-card-title class="pa-2 vehicles">
            <span class="mx-auto font-weight-bold white--text">
              <v-icon dark>mdi-router-wireless</v-icon>
            </span>
          </v-card-title>
          <div class="row cards-container">
            <monitorCard
              title="Total"
              code="total"
              color="#2f5293"
              @find="find"
              :number="trackerStatus.total"
              :numberBar="100"
            ></monitorCard>

            <monitorCard
              title="Online"
              code="online"
              color="#55ae69"
              @find="find"
              :number="trackerStatus.online.length"
              :numberBar="
                (trackerStatus.online.length * 100) / trackerStatus.total
              "
            >
            </monitorCard>

            <monitorCard
              title="24hrs sem comunicar"
              code="atLeast24hrs"
              color="#fec006"
              @find="find"
              :number="trackerStatus.atLeast24hrs.length"
              :numberBar="
                (trackerStatus.atLeast24hrs.length * 100) / trackerStatus.total
              "
            ></monitorCard>

            <monitorCard
              title="Offline"
              code="offline"
              color="#ff0000"
              @find="find"
              :number="trackerStatus.offline.length"
              :numberBar="
                (trackerStatus.offline.length * 100) / trackerStatus.total
              "
            ></monitorCard>
          </div>
        </v-card>
      </div>
    </div>

    <!-- Veículos e Mapa -->
    <div class="row">
      <div class="col sm-9">
        <div class="row mb-1">
          <div class="col mt-2 px-2">
            <v-card min-height="439px">
              <v-card-title class="pa-2 vehicles">
                <span class="mx-auto font-weight-bold white--text">
                  <v-icon dark>directions_car</v-icon>
                </span>
              </v-card-title>
              <v-text-field
                class="px-4 py-2"
                color="green"
                v-model="searchVehicle"
                append-icon="search"
                label="Filtrar"
                single-line
                hide-details
              ></v-text-field>

              <v-data-table
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [],
                }"
                no-data-text="Nenhum veículo cadastrado"
                no-results-text="Nenhum veículo encontrado"
                :items-per-page="10"
                class="px-2"
                :headers="headerVehicle"
                :items="vehiclesFilter"
                :search="searchVehicle"
                @click:row="setValuesRequest"
              >
                <template v-slot:[`item.maintenance`]="{ item }">
                  <v-icon
                    v-if="
                      item.maintenance.length > 0 &&
                        isVehicleInMaintenance(item.maintenance[0])
                    "
                    >build_circle</v-icon
                  >
                </template>
              </v-data-table>

              <div class="text-center pt-2" v-if="vehicleId">
                <div class="title orange--text text--darken-1">
                  Informações do veículo:
                </div>
                <div class="conteudoInfo pt-3">
                  <span>
                    <label class="titulo mb-0 subheading">Hodômetro:</label
                    >{{ vehicleInfos.hodometro | toKm }} KM
                  </span>
                  <span>
                    <label class="titulo mb-0 subheading"
                      >Voltagem bateria:</label
                    >{{ vehicleInfos.pwr_volt }} V
                  </span>
                </div>
                <div class="conteudoInfo pt-3">
                  <span>
                    <label class="titulo mb-0 subheading"
                      >Último envio de sinal:</label
                    >{{
                      vehicleInfos.last_report != null
                        ? new Date(vehicleInfos.last_report).toLocaleString()
                        : 'Carregando...'
                    }}
                  </span>
                  <span>
                    <v-icon
                      :class="getLastReportStatus(vehicleInfos.last_report)"
                      >swap_horizontal_circle</v-icon
                    >
                  </span>
                </div>
                <div class="conteudoInfo pt-3">
                  <span>
                    <label class="titulo mb-0 subheading">
                      Ignição:
                    </label>
                    {{
                      vehicleInfos.last_ignition.ignition_off
                        ? 'Desligada'
                        : 'Ligada'
                    }}
                  </span>
                  <span>
                    <v-icon
                      :class="
                        vehicleInfos.last_ignition.ignition_off
                          ? 'icon-gray'
                          : 'icon-green'
                      "
                      >mdi-engine</v-icon
                    >
                  </span>
                </div>
                <div class="conteudoInfo pt-3">
                  <span>
                    <label class="titulo mb-0 subheading"
                      >Próxima Manutenção:</label
                    >{{ vehicleInfos.next_mantenance }}
                  </span>
                </div>
              </div>

              <div class="text-center col-sm-12" v-if="vehicleId">
                <v-btn
                  color="success"
                  class="col-sm-3 ma-1"
                  @click="confirmation('openCar')"
                  >Abrir carro</v-btn
                >
                <v-btn
                  color="error"
                  class="col-sm-3 ma-1"
                  @click="confirmation('closeCar')"
                  >Fechar carro</v-btn
                >
              </div>
              <div class="text-center col-sm-12" v-if="vehicleId">
                <v-btn
                  color="error"
                  class="col-sm-4 ma-1"
                  @click="confirmation('disableVehicle')"
                  >Imobilizar carro</v-btn
                >
                <v-btn
                  color="success"
                  class="col-sm-4 ma-1"
                  @click="confirmation('enableVehicle')"
                  >Liberar Imobilização</v-btn
                >
              </div>
              <div class="text-center col-sm-12" v-if="vehicleId">
                <v-btn color="warning" @click="openMaintenanceModal"
                  >Criar manutenção</v-btn
                >
              </div>
            </v-card>
          </div>

          <div class="col-sm-12 col-lg-6 mt-2 px-2">
            <v-card min-height="439px" class="vehicles h-100">
              <v-card-title class="pa-2 vehicles">
                <span class="mx-auto font-weight-bold white--text">
                  <v-icon dark>map</v-icon>
                </span>
              </v-card-title>
              <GoogleMaps
                :destination="destination"
                :showRoute="showRoute"
                :origin="origin"
                :waypts="route"
              >
              </GoogleMaps>
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Reservas -->
    <div class="row pt-3">
      <div class="col px-2">
        <v-card min-height="410px">
          <v-card-title class="pa-2 requests">
            <span class="mx-auto font-weight-bold white--text">
              <v-icon dark>event</v-icon>
            </span>
          </v-card-title>
          <div class="row px-3">
            <div class="col px-1">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="px-4"
                    v-model="searchAgendamento"
                    label="Selecionar Data"
                    readonly
                    v-on="on"
                    color="orange darken-1"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="orange darken-1"
                  locale="pt-br"
                  v-model="searchAgendamento"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
              <v-data-table
                no-results-text="Nenhuma reserva na data selecionada"
                no-data-text="Nenhuma reserva para esse veículo"
                :items-per-page="5"
                class="px-2"
                :headers="headerRequests"
                :items="requests"
                :search="searchAgendamento"
              >
                <template v-slot:item="{ item }">
                  <tr
                    @click="getInfoRequest(item)"
                    :class="setColorRequest(item.id)"
                  >
                    <td class>{{ item.ordem }}</td>
                    <td class>{{ item.code }}</td>
                    <td class>{{ item.begin_date }}</td>
                    <td class>{{ item.end_date }}</td>
                    <td class>
                      <v-btn
                        :loading="loading"
                        class="ma-1"
                        color="success"
                        plain
                        @click="showEditReservationModal(item.id)"
                      >
                        Alterar reserva
                      </v-btn>
                      <v-btn
                        :disabled="isReservationLate(item)"
                        :loading="loading"
                        class="ma-1"
                        color="success"
                        plain
                        @click="extensionRequest(item)"
                      >
                        Prorrogar reserva
                      </v-btn>

                      <v-btn
                        v-if="item.code == 'check-in'"
                        :loading="loading"
                        class="ma-1"
                        color="success"
                        plain
                        @click="changeStepVehicleRequestId(item.id)"
                      >
                        Check-in
                      </v-btn>

                      <v-btn
                        v-if="item.code == 'check-in'"
                        :loading="loading"
                        class="ma-1"
                        color="error"
                        plain
                        @click="confirmationCancelByAdm(item.id)"
                      >
                        Cancelar
                      </v-btn>

                      <v-btn
                        v-if="item.code == 'check-out'"
                        :loading="loading"
                        class="ma-1"
                        color="error"
                        plain
                        @click="showChargeModal(item.id)"
                      >
                        Check-out
                      </v-btn>

                      <v-btn
                        v-if="item.code == 'check-out'"
                        :loading="loading"
                        class="ma-1"
                        color="success"
                        plain
                        @click="showSupplyModal(item.id)"
                      >
                        Cadastrar abastecimento
                      </v-btn>

                      <v-btn
                        :loading="loading"
                        class="ma-1"
                        color="info"
                        plain
                        @click="showModalVehicleChange(item.id)"
                      >
                        Alterar veículo
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div
              class="col-sm-12 col-md-4 col-lg-3 px-4 py-5 informacoes"
              v-if="infoRequest.user && infoRequestValues.body"
            >
              <div class="title orange--text text--darken-1">
                Informações reserva:
              </div>
              <div class="conteudoInfo pt-3">
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading">ID:</label
                  >{{ infoRequest.id }}
                </div>
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading">Nome:</label
                  >{{ infoRequest.user.name }}
                </div>
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading">Email:</label
                  >{{ infoRequest.user.email }}
                </div>
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading">Telefone:</label
                  >{{ infoRequest.user.phone }}
                </div>
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading">Valor da Reserva:</label
                  >R${{ infoRequestValues.body.vehicleRequestPriceInReais }}
                </div>
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading"
                    >Período reservado:</label
                  >{{ infoRequestValues.body.minutesSpent }}
                </div>
                <div class="grey--text text--darken-2 subheading mb-1">
                  <label class="titulo mb-0 subheading">Multa:</label>R${{
                    infoRequestValues.body.normalizedMulct
                  }}
                </div>
                <v-container class="d-flex justify-center">
                  <v-btn small @click="redirectToRequestDetails">
                    <v-icon style="padding-right: 5px;">assignment</v-icon>
                    <span>Detalhes da reserva</span>
                  </v-btn>
                </v-container>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- Modal -->
    <v-layout row justify-center>
      <ModalCheck
        :showModal="dialogConfirmation"
        :formFields="formFields"
        :msgConfirmation="msgConfirmation"
        :command="command"
        @btnNao="btnNao()"
        @btnSim="btnSim(command)"
      ></ModalCheck>
    </v-layout>

    <ModalCobrancaCheckOut
      :dialog="showModalCobranca"
      :vehicleRequestId="vehicleRequestId"
      :vehicleRequestValues="vehicleRequestValues"
      :formFields="formFields"
      @disagree="showModalCobranca = false"
      @agree="finishReservationByAdm"
    ></ModalCobrancaCheckOut>

    <ModalCreateSupply
      :dialog="showModalSupply"
      :vehicleRequestId="vehicleRequestId"
      @disagree="showModalSupply = false"
      @agree="createSupplyByVehicleRequest"
    ></ModalCreateSupply>

    <ModalChangeVehicle
      :dialog="showModalChangeVehicle"
      :vehicleRequestId="vehicleRequestId"
      :currentVehicle="currentVehicle"
      @disagree="showModalChangeVehicle = false"
      @agree="changeVehicle"
    ></ModalChangeVehicle>

    <ModalExtendReservation
      :dialog="showModalExtensao"
      :item="requestItem"
      @finish="(showModalExtensao = false), getRequests()"
    ></ModalExtendReservation>

    <ModalCancelReservation
      :dialog="showModalCancel"
      :vehicleRequestId="vehicleRequestId"
      @disagree="showModalCancel = false"
      @agree="cancelByAdm"
    ></ModalCancelReservation>

    <ModalEditReservation
      :dialog="showModalEdit"
      :vehicleRequestId="vehicleRequestId"
      @disagree="showModalEdit = false"
      @agree="updateByAdm"
    ></ModalEditReservation>

    <ModalCreateMaintenance
      :maintenance_type_modal="this.maintenance_type_modal"
      @btnNao="maintenance_type_modal = false"
      @btnSim="createMaintenance"
    ></ModalCreateMaintenance>
  </div>
</template>

<script>
import VehicleController from '../../controllers/VehicleController.js';
import MaintenanceController from '../../controllers/MaintenanceController.js';
import VehicleRequestController from '../../controllers/VehicleRequestController.js';
import FormAnsweredController from '../../controllers/FormAnsweredController';
import DateHelper from '../../helpers/DateHelper';

import ClientController from '../../controllers/ClientController.js';
import UserController from '../../controllers/UserController.js';
import WalletController from '../../controllers/WalletController.js';
import HistoricoAbastecimentoController from '../../controllers/HistoricoAbastecimentoController.js';

import ModalCobrancaCheckOut from '../tcs/ModalCobrancaCheckOut';
import ModalCreateMaintenance from './ModalCreateMaintenance.vue';
import ModalExtendReservation from '../tcs/ModalExtendReservation.vue';
import ModalCancelReservation from '../tcs/ModalCancelReservation';
import ModalEditReservation from '../tcs/ModalEditReservation';
import ModalCreateSupply from '../tcs/ModalCreateSupply.vue';
import ModalChangeVehicle from '../tcs/ModalChangeVehicle.vue';

import NumberHelper from '../../helpers/NumberHelper';

import GoogleMaps from './GoogleMaps';
import moment from 'moment';
import Constants from '../../models/constants/ConstantsRoutes.js';
import TrackerController from '../../controllers/TrackerController';
import monitorCard from './monitorCard';
import ModalCheck from './ModalCheck';

export default {
  components: {
    GoogleMaps,
    ModalCobrancaCheckOut,
    ModalCreateMaintenance,
    ModalCreateSupply,
    ModalExtendReservation,
    ModalCancelReservation,
    monitorCard,
    ModalEditReservation,
    ModalCheck,
    ModalChangeVehicle,
  },

  created() {
    this.vehicleController = new VehicleController(this.$resource);
    this.maintenanceController = new MaintenanceController(this.$resource);
    this.vehicleRequestController = new VehicleRequestController(
      this.$resource
    );
    this.clientController = new ClientController(this.$resource);
    this.userController = new UserController(this.$resource);
    this.formAnsweredController = new FormAnsweredController(this.$resource);
    this.walletController = new WalletController(this.$resource);
    this.trackerController = new TrackerController(this.$resource);
    this.historicoAbastecimentoController = new HistoricoAbastecimentoController(
      this.$resource
    );

    this.getVehicles();
    this.getTrackerStatus();
    this.searchClients();

    setInterval(this.moment, 1000);
  },

  data: () => ({
    route: [],
    loading: false,
    showModalSupply: false,
    showModalCobranca: false,
    showModalExtensao: false,
    showModalCancel: false,
    showModalEdit: false,
    dialogConfirmation: false,
    showModalChangeVehicle: false,
    requestItem: {},
    promotionPrice: 0,
    promotionDescription: '',
    menu2: false,
    searchVehicle: '',
    vehicleController: null,
    idSelectedVehicle: '',
    idSelectedRequest: '',
    rowsperpage5: [5],
    notsingleClient: true,
    rowsperpage4: [4],
    headerVehicle: [
      { text: 'Cliente', value: 'client.name' },
      { text: 'Modelo', value: 'vehicle_model.model' },
      { text: 'Placa', value: 'plate' },
      { text: '', value: 'maintenance', descending: false },
    ],
    vehicle: [],
    searchAgendamento: '',
    headerRequests: [
      { text: 'Ordem', value: 'ordem' },
      { text: 'Status', value: 'code' },
      { text: 'Check-in', value: 'begin_date' },
      { text: 'Check-out', value: 'end_date' },
      { text: 'Ações', value: 'action', sortable: false },
    ],
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: true,
    },
    requests: [],
    infoRequest: [],
    infoRequestValues: [],
    origin: '',
    destination: '',
    showRoute: false,
    vehicleId: null,
    address: null,
    msgConfirmation: null,
    vehiclePlate: null,
    isMaintenance: false,
    command: null,
    vehicleRequestId: 10076,
    vehicleRequestValues: {},
    dateNow: null,
    maintenanceId: null,
    maintenance_type_modal: false,
    isLoadingClient: false,
    isLoadingUser: false,
    Vclient: [],
    clients: [],
    users: [],
    balanceModal: false,
    idHold: 0,
    vehicleInfos: {},
    alltrackers: null,
    vehiclesFilter: [],
    currentVehicle: {},

    trackers: [],
    trackerStatus: {
      total: 0,
      online: 0,
      offline: 0,
      atLeast24hrs: 0,
    },

    formFields: null,
    formImages: {},
    image: null,
    interval: null,
  }),

  methods: {
    openMaintenanceModal() {
      this.maintenance_type_modal = true;
    },
    async createMaintenance(maintenance) {
      try {
        let selectedVehicle = this.vehicle.filter(
          item => this.vehicleId == item.id
        );
        let clientId = selectedVehicle[0].client_id;
        let response = await this.maintenanceController.createMaintenance({
          ...maintenance,
          vehicle_id: this.vehicleId,
          client_id: clientId,
        });
        this.maintenance_type_modal = false;
        this.getVehicleInfos();
        if (response.body.message)
          return this.$awn.alert(response.body.message);
        return this.$awn.success('Manutenção criada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    isReservationLate(request) {
      let response =
        this.dateNow > moment(request.end_date).toISOString(true)
          ? true
          : false;

      return response;
    },
    isVehicleInMaintenance(maintenance) {
      return (
        this.dateNow >
        moment(maintenance.begin_date).format('YYYY-MM-DD HH:mm:ss')
      );
    },
    // async getVehicleRoute(vehicleId) {
    //   this.route = [];
    //   try {
    //     const request = await this.vehicleRequestController.getVehicleRequestsByVehicleId(
    //       vehicleId
    //     );

    //     if (request.length > 0) {
    //       if (request[0].code == 'check-out') {
    //         const requestDuration = moment(this.dateNow).diff(
    //           moment(request[0].begin_date),
    //           'hours'
    //         );

    //         console.log('duration', requestDuration);

    //         let beginDate = moment()
    //           .subtract(10, 'minutes')
    //           .format('YYYY[-]MM[-]DD HH:mm');
    //         // requestDuration > 24
    //         //   ? moment(request[0].begin_date)
    //         //       .subtract(1, 'day')
    //         //       .format('YYYY[-]MM[-]DD HH:mm')
    //         //   : moment(request[0].begin_date)
    //         //       .subtract(3, 'h')
    //         //       .format('YYYY[-]MM[-]DD HH:mm');

    //         console.log('begin', beginDate);

    //         let endDate = moment().format('YYYY[-]MM[-]DD HH:mm');
    //         // requestDuration > 24
    //         //   ? moment(this.dateNow)
    //         //       .add(1, 'day')
    //         //       .format('YYYY[-]MM[-]DD HH:mm')
    //         //   : moment(this.dateNow)
    //         //       .add(3, 'h')
    //         //       .format('YYYY[-]MM[-]DD HH:mm');

    //         console.log('end', endDate);

    //         await this.vehicleRequestController
    //           .getVehicleRoute(vehicleId, beginDate, endDate)
    //           .then(res => {
    //             if (res.body.length == 0) {
    //               throw 'Sem rotas!';
    //             } else {
    //               this.setRouteArray(res.body);
    //             }
    //           })
    //           .catch(error => console.log(error));
    //       }
    //     }
    //   } catch (error) {
    //     this.$awn.alert(error);
    //   }
    // },

    //Formata o array como location = "lat, long" pra renderizar a rota
    setRouteArray(route) {
      this.route = route.map(item => {
        const container = {};
        container.location = item.latitude + ', ' + item.longitude;
        return container;
      });

      let lastLocalization = route.length - 1;
      //ultima localização como destino
      this.destination = {
        lat: route[lastLocalization].latitude,
        lng: route[lastLocalization].longitude,
      };

      this.origin = {
        lat: route[0].latitude,
        lng: route[0].longitude,
      };

      this.route = this.optimizeArray(this.route);
    },
    optimizeArray(array) {
      //método recursivo, até o array ser menor ou igual ao 23 ,limite total de rotas
      const optimized = [];
      let size = array.length;

      //entre 24 e 35
      if (size >= 24 && size <= 35) {
        for (let i = 0; i < size; i = i + 7) {
          array.splice(i, 1);
          return this.optimizeArray(array);
        }
        //entre 36 e 40
      } else if (size >= 36 && size < 40) {
        for (let i = 0; i < size; i = i + 4) {
          array.splice(i, 1);
          return this.optimizeArray(array);
        }
      }
      if (size >= 40) {
        for (let i = 0; i < size; i = i + 2) {
          optimized.push(array[i]);
        }

        //pega a ultima localização e coloca no novo array
        let lastLocalization = optimized.length - 1;

        optimized[lastLocalization] = array[size - 1];

        return this.optimizeArray(optimized);
      } else {
        return array;
      }
    },

    showEditReservationModal(vehicleRequestId) {
      this.vehicleRequestId = vehicleRequestId;
      this.showModalEdit = true;
    },

    async showChargeModal(vehicleRequestId) {
      this.formFields = await this.vehicleRequestController.getVehicleRequestFormFields(
        vehicleRequestId
      );

      this.formAnsweredController
        .getCurrentReservationValue(vehicleRequestId)
        .then(res => {
          this.vehicleRequestId = vehicleRequestId;
          this.vehicleRequestValues = res.body;
          this.showModalCobranca = true;
        })
        .catch(error => this.$awn.alert(error.body.message));
    },
    extensionRequest(item) {
      this.showModalExtensao = true;
      this.requestItem = item;
    },

    async finishReservationByAdm(checkoutValues, formImages) {
      checkoutValues.mulctValueFormated = NumberHelper.convertMoneyToInteger(
        checkoutValues.mulctValue
      );
      checkoutValues.quilometragemValueFormated = NumberHelper.convertMoneyToInteger(
        checkoutValues.quilometragemValue
      );

      let data = new FormData();
      data.append('form', JSON.stringify({ checkoutValues }));

      if (formImages) {
        for (let [formFieldId, imageFile] of Object.entries(formImages)) {
          data.append(formFieldId, imageFile);
        }
      }
      this.showModalCobranca = false;
      await this.$awn.async(
        this.formAnsweredController.finishReservationByAdm(data).then(
          res => {
            this.$awn.success(res.body.message);
          },
          err => {
            this.$awn.alert(err.message);
          }
        ),
        false,
        false,
        'Enviando dados'
      );
      this.getRequests();
    },

    async showModalVehicleChange(vehicleRequestId) {
      this.vehicleRequestId = vehicleRequestId;
      await this.getCurrentVehicle(vehicleRequestId);
      this.showModalChangeVehicle = true;
    },

    async getCurrentVehicle(vehicleRequestId) {
      this.currentVehicle = {};
      const vehicleRequest = await this.vehicleRequestController.getById(
        vehicleRequestId
      );
      this.currentVehicle = vehicleRequest.vehicle;
    },

    async changeVehicle(vehicleRequestId, newVehicle) {
      try {
        if (!newVehicle.id) {
          this.$awn.alert('Escolha um veículo!');
          return;
        }

        if (newVehicle.id === this.currentVehicle.id) {
          this.$awn.alert('Escolha um veículo diferente do atual!');
          return;
        }

        const res = await this.vehicleRequestController.updateVehicle(
          vehicleRequestId,
          newVehicle.id
        );
        if (res.ok) {
          this.showModalChangeVehicle = false;
          this.$awn.success(res.message);
        } else {
          this.$awn.alert(res.message);
        }
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },

    async showSupplyModal(vehicleRequestId) {
      this.vehicleRequestId = vehicleRequestId;
      this.showModalSupply = true;
    },
    createSupplyByVehicleRequest(supplyValue, image, vehicleRequestId) {
      const form = {
        vehicleRequestId: vehicleRequestId,
        vlrNota: supplyValue,
      };

      let data = new FormData();

      data.append('file', image);
      data.append('form', JSON.stringify(form));

      this.historicoAbastecimentoController
        .createSupplyByVehicleRequest(data)
        .then(res => {
          this.showModalSupply = false;
          this.$awn.success(res.message);
        })
        .catch(e => {
          console.log(e);
          this.$awn.alert(e.body.message);
        });
    },

    moment: function() {
      this.dateNow = moment().format('YYYY-MM-DD HH:mm:ss');
    },

    getLastReportStatus(last_report) {
      let status = '';
      if (last_report != null) {
        let difference =
          (new Date().getTime() - new Date(last_report).getTime()) / 1000;
        if (difference < 1020) status = 'icon-green';
        else if (difference >= 1020 && difference <= 1500)
          status = 'icon-orange';
        else if (difference > 1500) status = 'icon-red';
      }

      return status;
    },

    getConfigMinuteStep() {
      return Number(Constants.CONFIG_MINUTE_STEP_DATE_TIME_DEFAULT);
    },

    btnSim(command) {
      switch (command) {
        case 'openCar':
          this.openCar();
          break;
        case 'closeCar':
          this.closeCar();
          break;
        case 'enableVehicle':
          this.enableVehicle();
          break;
        case 'disableVehicle':
          this.disableVehicle();
          break;
        case 'changeStep':
          this.changeStep();
          break;
        case 'closeMaintenance':
          this.closeMaintenance();
          break;
      }
    },

    async confirmation(command) {
      this.command = command;
      switch (command) {
        case 'openCar':
          this.msgConfirmation = `abrir o veículo ${this.vehiclePlate} ?`;
          // this.command = this.openCar;
          this.dialogConfirmation = true;
          break;
        case 'closeCar':
          this.msgConfirmation = `fechar o veículo ${this.vehiclePlate} ?`;
          // this.command = this.closeCar;
          this.dialogConfirmation = true;
          break;
        case 'enableVehicle':
          this.msgConfirmation = `desbloquear o veículo ${this.vehiclePlate} ?`;
          // this.command = this.enableVehicle;
          this.dialogConfirmation = true;
          break;
        case 'disableVehicle':
          this.msgConfirmation = `imobilizar o veículo ${this.vehiclePlate} ?`;
          // this.command = this.disableVehicle;
          this.dialogConfirmation = true;
          break;
        case 'changeStep':
          this.formFields = await this.vehicleRequestController.getVehicleRequestFormFields(
            this.vehicleRequestId
          );
          this.msgConfirmation = `alterar o status da reserva ?`;
          // this.command = this.changeStep;
          this.dialogConfirmation = true;
          break;
        case 'closeMaintenance':
          this.msgConfirmation = `fechar a manutenção do veículo ${this.vehiclePlate} ?`;
          // this.command = this.closeMaintenance;
          this.dialogConfirmation = true;
          break;
      }
    },

    async enableVehicle() {
      let res = await this.vehicleController.changeStatus(
        this.vehicleId,
        'enableVehicle'
      );
      if (res.error) {
        this.$awn.alert('Falha o enviar comando');
      } else {
        this.$awn.success('Comando enviado!');
      }
      this.dialogConfirmation = false;
    },

    async disableVehicle() {
      let res = await this.vehicleController.changeStatus(
        this.vehicleId,
        'disableVehicle'
      );
      if (res.error) {
        this.$awn.alert('Falha o enviar comando');
      } else {
        this.$awn.success('Comando enviado!');
      }
      this.dialogConfirmation = false;
    },

    async openCar() {
      let res = await this.vehicleController.changeStatus(
        this.vehicleId,
        'unlock'
      );
      if (res.error) {
        this.$awn.alert('Falha o enviar comando');
      } else {
        this.$awn.success('Comando enviado!');
      }
      this.dialogConfirmation = false;
    },

    async closeCar() {
      let res = await this.vehicleController.changeStatus(
        this.vehicleId,
        'lock'
      );
      if (res.error) {
        this.$awn.alert('Falha o enviar comando');
      } else {
        this.$awn.success('Comando enviado!');
      }
      this.dialogConfirmation = false;
    },

    // Check-in
    async changeStepVehicleRequestId(vehicleRequestId) {
      this.vehicleRequestId = vehicleRequestId;
      this.confirmation('changeStep');
    },

    confirmationCancelByAdm(vehicleRequestId) {
      this.vehicleRequestId = vehicleRequestId;
      this.showModalCancel = true;
    },

    cancelByAdm(motivo, estorno, password) {
      this.loading = true;
      this.vehicleRequestController
        .cancelByAdm(this.vehicleRequestId, motivo, estorno, password)
        .then(res => {
          this.$awn.success(res.message);
          this.getRequests();
          this.showModalCancel = false;
        })
        .catch(error =>
          this.$awn.alert(error.body.message ? error.body.message : error.body)
        )
        .finally((this.loading = false));
    },

    updateByAdm(beginDate) {
      this.loading = true;
      this.vehicleRequestController
        .updateCheckInDateByAdm(this.vehicleRequestId, beginDate)
        .then(res => {
          this.$awn.success(res.message);
          this.getRequests();
          this.showModalEdit = false;
        })
        .catch(error => this.$awn.alert(error.body.message))
        .finally(() => {
          this.loading = false;
        });
    },

    changeStep() {
      var data = new FormData();

      if (Object.keys(this.formImages).length > 0) {
        for (let [formFieldId, imageFile] of Object.entries(this.formImages)) {
          data.append(formFieldId, imageFile);
        }
      }

      this.formAnsweredController
        .forceChangeStep(this.vehicleRequestId, data)
        .then(res => {
          this.$awn.success(res.body.message);
        })
        .catch(error => {
          this.$awn.alert(error.body.message);
        })
        .finally(() => {
          this.getRequests();
        });

      this.dialogConfirmation = false;
    },

    openMaintenance() {
      this.maintenance_type_modal = true;
    },

    async getVehicles() {
      try {
        this.blockScreen = true;
        this.vehicle = await this.vehicleController.getAllVehicles();
        this.vehiclesFilter = this.vehicle;
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    async setValuesRequest(value) {
      this.vehiclePlate = value.plate;
      this.vehicleId = value.id;
      this.address = value.garage.address;
      this.isMaintenance = value.maintenance.length > 0;
      this.maintenanceId =
        value.maintenance.length > 0 ? value.maintenance[0].id : 0;
      this.infoRequest.user = null;
      await this.getVehicleInfos();
      this.getRequests();
    },

    async getVehicleInfos() {
      this.vehicleInfos = await this.vehicleController.getInfosByVehicleId(
        this.vehicleId
      );
      console.log(this.vehicleInfos);
    },

    async getRequests() {
      try {
        this.idSelectedVehicle = this.vehicleId;
        this.requests = [];
        this.requests = await this.vehicleController.getVehicleRequestsByVehicleId(
          this.vehicleId
        );
        this.destination = {
          lat: this.address.latitude,
          lng: this.address.longitude,
        };
        this.origin = {
          lat: this.vehicleInfos.latitude,
          lng: this.vehicleInfos.longitude,
        };
        this.showRoute = !this.showRoute;
      } catch (error) {
        this.origin = this.destination;
        this.showRoute = !this.showRoute;
        this.$awn.alert('Falha ao localizar veículo');
      }
    },

    async getInfoRequest(request) {
      await this.getData(request.id);
    },

    async getData(requestId) {
      this.idSelectedRequest = requestId;
      this.infoRequest = await this.vehicleRequestController.getById(requestId);
      this.infoRequestValues = await this.vehicleRequestController.getPricePrewiew(
        this.infoRequest.begin_date,
        this.infoRequest.end_date,
        this.infoRequest.vehicle_id,
        this.infoRequest.beginOdometer,
        this.infoRequest.endOdometer
      );
      this.infoRequestValues.body.minutesSpent = this.convertMinutesToHoursFormat(
        this.infoRequestValues.body.minutesSpent
      );
      if (this.infoRequestValues.body.vehicleRequestPriceInReais)
        this.infoRequestValues.body.vehicleRequestPriceInReais = this.infoRequestValues.body.vehicleRequestPriceInReais.toFixed(
          2
        );
    },
    btnNao() {
      this.dialogConfirmation = false;
      this.formImages = {};
      this.image = null;
    },

    convertMinutesToHoursFormat(num) {
      let days = 0;
      let hours = 0;
      let minutes = 0;

      if (num >= 1440) {
        days = num / 1440;
      }

      if (num >= 60) {
        hours = (num % 1440) / 60;
      }
      minutes = num % 60;
      return `${Math.floor(days)} dia(s), ${Math.floor(
        hours
      )} hora(s) e ${minutes} minuto(s)`;
    },

    setColor(id) {
      if (id == this.idSelectedVehicle) return 'grey lighten-2';
      return 'transparent';
    },

    setColorRequest(id) {
      if (id == this.idSelectedRequest) return 'grey lighten-2';
      return 'transparent';
    },

    async searchUsersFromClient() {
      try {
        if (this.Vclient.length != 1) {
          this.notsingleClient = true;
          this.users = [];
          return;
        } else {
          this.notsingleClient = false;
          this.idHold = this.Vclient[0].id;
        }

        this.isLoadingUser = true;
        this.users = await this.userController.getUsersActiveByClientId(
          this.idHold
        );
      } catch (error) {
        return this.$awn.alert('Erro ao obter usuários');
      } finally {
        this.isLoadingUser = false;
      }
    },
    async searchClients() {
      try {
        // Clients have already been loaded or Items have already been requested
        if (this.clients.length > 0 || this.isLoadingClient) {
          return;
        }
        this.isLoadingClient = true;
        this.clients = await this.clientController.getAllClients();
      } catch (error) {
        return this.$awn.alert('Erro ao obter clientes');
      } finally {
        this.isLoadingClient = false;
      }
    },

    async getTrackerStatus() {
      try {
        this.blockScreen = true;
        this.trackerStatus = await this.trackerController.getStatus();
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    find(code) {
      this.vehicleId = null;

      if (code != 'total') {
        let trackers = this.trackerStatus[code].map(tracker => tracker.imei);
        this.vehiclesFilter = this.vehicle.filter(vehicle =>
          trackers.includes(vehicle.imei)
        );
      } else {
        this.vehiclesFilter = this.vehicle;
      }
    },

    inputChanged(formFieldId) {
      this.formImages[formFieldId] = this.image;
      this.image = null;
    },
    redirectToRequestDetails() {
      const routeData = this.$router.resolve({
        name: Constants.ROUTER_NAME_TCS_VEHICLE_REQUEST_DETAIL,
        params: {
          id: this.infoRequest.id,
        },
      });
      window.open(routeData.href, '_blank');
      localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
    },
  },

  computed: {
    clientItems() {
      return this.clients.map(client => {
        return {
          id: client.id,
          name: client.name,
        };
      });
    },
  },

  filters: {
    toKm(metros) {
      if (metros) {
        return Number.parseFloat(metros / 1000).toFixed(2);
      }
    },
  },
};
</script>

<style scoped>
.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}

.inputs {
  border: 1px solid rgb(173, 173, 173);
  border-radius: 6px;
  width: 90%;
  margin: 0 auto !important;
  display: flex;
}

.vehicles {
  background-color: var(--primary-color);
}

.informacoes {
  border-left: 0.5px solid rgb(212, 212, 212);
}

.titulo {
  color: grey;
  padding-right: 10px;
}

.requests {
  background-color: var(--orange-color);
}

i.icon-green {
  color: green;
}

i.icon-orange {
  color: orange;
}

i.icon-red {
  color: red;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;
}
</style>
